import { createFileRoute, Outlet } from "@tanstack/react-router";
import { RequirePermission } from "@/components/universal/require-permission";
import NotFoundPage from "@/catchall";

export const Route = createFileRoute("/_private/product")({
  component: ProductLayout,
});

function ProductLayout() {
  return (
    <RequirePermission permission="catalog" fallback={<NotFoundPage />}>
      <Outlet />
    </RequirePermission>
  );
}
